export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_GRAPH_TIME_PERIOD = 'SET_GRAPH_TIME_PERIOD';
export const TOGGLE_CODE_MODAL = 'TOGGLE_CODE_MODAL';
